import React from "react";

import { IsWorkingCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function isWorking({ width, onResize }: Column.Options) {
	return base(ColumnId.IsWorking, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default isWorking;
